var map = {
	"./3CRV.svg": 99472,
	"./3dots.svg": 22965,
	"./404.svg": 38418,
	"./Aki-logo.svg": 92309,
	"./BNBX.png": 5898,
	"./BSC.svg": 99850,
	"./BUSD.png": 83446,
	"./BUSD.svg": 28448,
	"./BrowserWallet.png": 28533,
	"./DAI.png": 97828,
	"./DAI.svg": 98992,
	"./ETH.svg": 56891,
	"./HAY.png": 22896,
	"./MGP.png": 72590,
	"./MGP.svg": 59046,
	"./MetaMask.png": 49211,
	"./OG.svg": 94112,
	"./OP.svg": 30895,
	"./POLYGON.svg": 14068,
	"./USDC.png": 17927,
	"./USDC.svg": 51521,
	"./USDT.png": 7960,
	"./USDT.svg": 95054,
	"./WBNB.png": 31319,
	"./WOM.svg": 11573,
	"./WalletConnect.png": 65037,
	"./WalletConnect.svg": 50317,
	"./account.svg": 60919,
	"./add.svg": 29475,
	"./add2.svg": 99355,
	"./addUser.svg": 42514,
	"./address.svg": 40950,
	"./alert.svg": 24608,
	"./alertLg.svg": 76243,
	"./analysis.svg": 31696,
	"./approve.svg": 29529,
	"./aptos.png": 78565,
	"./arbitrum.svg": 57872,
	"./arcadegalaxy-header.png": 69572,
	"./arrowDown.svg": 18057,
	"./arrowRight.svg": 62697,
	"./avax.png": 34758,
	"./azukiHeader.svg": 59840,
	"./back.png": 77461,
	"./backButton.svg": 98303,
	"./bind.svg": 98859,
	"./bindDiscord.svg": 89769,
	"./bindTelegram.svg": 60222,
	"./bindTwitter.svg": 58896,
	"./boxOpen.svg": 48305,
	"./bsc.png": 75546,
	"./cancel.svg": 94016,
	"./chat-logo.png": 2308,
	"./check.svg": 14414,
	"./check2.svg": 99168,
	"./checkbox.svg": 11453,
	"./checked.svg": 41985,
	"./checkedbox.svg": 87844,
	"./clickToConnect.svg": 9289,
	"./close.png": 23474,
	"./close.svg": 48298,
	"./colorDiscord.svg": 15805,
	"./colorTelegram.svg": 75090,
	"./connect.png": 84832,
	"./connectButton.png": 3948,
	"./connectHeaderLeft.svg": 62512,
	"./connectHeaderRight.svg": 2207,
	"./connectWallet1.svg": 74460,
	"./connectWallet2.svg": 76783,
	"./connectWallet3.svg": 56734,
	"./copy.svg": 22541,
	"./copyBlue.svg": 25065,
	"./count.png": 33047,
	"./createSurvey.svg": 2048,
	"./createSurveyBlue.svg": 20220,
	"./createSurveyRed.svg": 64101,
	"./creatorConnect.png": 26106,
	"./creatorLoginBg.png": 87334,
	"./crown.svg": 10719,
	"./crv.svg": 28477,
	"./curveBanner.png": 22645,
	"./curveSupportCenter.svg": 24763,
	"./customer.svg": 87886,
	"./dScheduleDemo.svg": 24284,
	"./defaultAdmin.svg": 4874,
	"./defaultBanner.png": 26551,
	"./defaultBanner2.png": 27653,
	"./defaultDiscordBanner.png": 56243,
	"./defaultTwitterBanner.png": 72834,
	"./defaultUser.svg": 5580,
	"./delete.svg": 65863,
	"./dice.svg": 36771,
	"./discord.png": 12894,
	"./discord.svg": 82146,
	"./distribute.svg": 68211,
	"./distribution.svg": 88360,
	"./dolphin.svg": 21358,
	"./download.svg": 92446,
	"./edit.svg": 69338,
	"./editButton.svg": 20378,
	"./editR.svg": 9924,
	"./editY.svg": 46015,
	"./email.svg": 90554,
	"./empty.svg": 50789,
	"./error.png": 76080,
	"./error.svg": 56660,
	"./eth.png": 73775,
	"./eye.svg": 85297,
	"./farming.svg": 76422,
	"./file.svg": 49556,
	"./filter.svg": 79500,
	"./footerLogo.svg": 4566,
	"./form.png": 43438,
	"./form.svg": 90308,
	"./forward.png": 26837,
	"./freeConnect.svg": 93306,
	"./gift.svg": 41816,
	"./gift2.svg": 39354,
	"./gigabyte-header.png": 99414,
	"./gitbook.svg": 55557,
	"./greaterThan.svg": 6089,
	"./header.svg": 37769,
	"./headerDeco.svg": 41654,
	"./ic_alpacaAllWhite.svg": 58339,
	"./ic_alpacaAllWhiteBigFace.svg": 66388,
	"./ic_alpacaBlacBigFace.svg": 71226,
	"./ic_alpacaBlack.svg": 36012,
	"./ic_alpacaBlue.svg": 2863,
	"./ic_alpacaBlueBigFace.svg": 86224,
	"./ic_alpacaGreen.svg": 25940,
	"./ic_alpacaGreenBigFace.svg": 87481,
	"./ic_alpacaPink.svg": 16047,
	"./ic_alpacaPinkBigFace.svg": 8592,
	"./ic_alpacaPurple.svg": 65973,
	"./ic_alpacaPurpleBigFace.svg": 11058,
	"./ic_alpacaWhite.svg": 14858,
	"./ic_alpacaWhiteHairBigFace.svg": 59411,
	"./ic_alpacaYellow.svg": 82171,
	"./ic_alpacaYellowBigFace.svg": 65324,
	"./image.svg": 70213,
	"./imageMagpie.png": 35808,
	"./imageMagpie.svg": 11172,
	"./info.svg": 2310,
	"./joinNow.svg": 9802,
	"./joinNow2.svg": 98356,
	"./jonesdao-header.png": 49829,
	"./jonesdao-logo.png": 43943,
	"./landingHeader.png": 7688,
	"./landingHeader.svg": 91144,
	"./landingTitle.svg": 14763,
	"./landing_bg2.svg": 20467,
	"./landing_bg3-1.svg": 24992,
	"./landing_bg3-2.svg": 32083,
	"./landing_bg4.jpg": 32205,
	"./landing_bg5.jpg": 31280,
	"./landing_restriction.svg": 59400,
	"./landing_surveyToEarn.jpg": 36691,
	"./landing_surveyToEarn.svg": 99833,
	"./landing_userAnalysis.svg": 60725,
	"./layout_background.svg": 14323,
	"./layout_background_s.svg": 82737,
	"./layout_center.svg": 64200,
	"./layout_center_s.svg": 37070,
	"./layout_left.svg": 32452,
	"./layout_leftCover.svg": 40381,
	"./layout_leftCover_s.svg": 51251,
	"./layout_left_s.svg": 45554,
	"./layout_right.svg": 83307,
	"./layout_rightCover.svg": 92588,
	"./layout_rightCover_s.svg": 49866,
	"./layout_right_s.svg": 2617,
	"./line.svg": 98400,
	"./link.svg": 86342,
	"./linkTo.svg": 46941,
	"./list.svg": 74506,
	"./loading.gif": 30517,
	"./lock.svg": 91447,
	"./lockIcon.png": 81102,
	"./login.png": 65005,
	"./login.svg": 5253,
	"./loginW.svg": 59328,
	"./loginwhite.svg": 95088,
	"./logo.png": 65549,
	"./logo.svg": 67503,
	"./mWOM.png": 25352,
	"./mWOM.svg": 65270,
	"./magpie.svg": 52435,
	"./magpieAdmin.svg": 8728,
	"./magpieBg.svg": 22670,
	"./magpieHeader.svg": 74380,
	"./magpieUser.png": 93328,
	"./maintenance.svg": 43599,
	"./martian.png": 64714,
	"./metaBg.svg": 22016,
	"./metachat-chat-icon.svg": 26968,
	"./metachat-launcher-close-icon.png": 64357,
	"./metachat-launcher-open-icon.svg": 71753,
	"./metachat.svg": 51387,
	"./metacrm.svg": 22951,
	"./metadesk.svg": 5134,
	"./metadeskHeader.svg": 16809,
	"./metadesk_connect.png": 25323,
	"./metadesk_connect_btn.png": 92566,
	"./metaformHeader.png": 96358,
	"./metaformHeader.svg": 2784,
	"./metaform_login.svg": 32121,
	"./mixverse-header.png": 72447,
	"./mixverse-logo.png": 10465,
	"./more.png": 52419,
	"./moreButton.png": 77151,
	"./moveto.svg": 71398,
	"./multipleText.svg": 36503,
	"./new.svg": 55996,
	"./newbie.svg": 94788,
	"./next.png": 64299,
	"./noTicket.svg": 35587,
	"./normal.svg": 42235,
	"./op.png": 92597,
	"./overview.svg": 56555,
	"./paraspace-header.png": 30265,
	"./partners/dao1.svg": 98599,
	"./partners/dao2.svg": 27092,
	"./partners/dao3.svg": 52725,
	"./partners/defi1.svg": 15685,
	"./partners/defi2.svg": 79462,
	"./partners/defi3.svg": 42263,
	"./partners/defi4.svg": 47192,
	"./partners/defi5.svg": 22697,
	"./partners/defi6.svg": 80762,
	"./partners/gamefi1.svg": 8828,
	"./partners/gamefi10.svg": 26756,
	"./partners/gamefi11.svg": 77925,
	"./partners/gamefi12.svg": 55494,
	"./partners/gamefi2.svg": 87855,
	"./partners/gamefi3.svg": 25278,
	"./partners/gamefi4.svg": 50561,
	"./partners/gamefi5.svg": 38320,
	"./partners/gamefi6.svg": 83459,
	"./partners/gamefi7.svg": 45522,
	"./partners/gamefi8.svg": 69013,
	"./partners/gamefi9.svg": 27028,
	"./partners/media1.svg": 9263,
	"./partners/media2.svg": 6940,
	"./partners/media3.svg": 35485,
	"./partners/nft1.svg": 88267,
	"./partners/nft2.svg": 30200,
	"./partners/nft3.svg": 39209,
	"./pdf.svg": 39392,
	"./pen.svg": 4527,
	"./petra.png": 44582,
	"./phantom.png": 50061,
	"./phone.svg": 89070,
	"./plus-circle.svg": 73423,
	"./polygon.png": 32240,
	"./pontem.svg": 20705,
	"./poweredBy.svg": 25849,
	"./preview.png": 25214,
	"./preview.svg": 40714,
	"./previewIcon.svg": 61257,
	"./preview_white.svg": 22540,
	"./radiantBanner.png": 43525,
	"./radiantHeader.png": 39456,
	"./radiantHeader.svg": 89888,
	"./radio.svg": 70651,
	"./range.svg": 59149,
	"./redLock.png": 29882,
	"./remove.svg": 18866,
	"./response.svg": 21471,
	"./responses.svg": 8670,
	"./restriction.svg": 32228,
	"./right.svg": 24496,
	"./rise.png": 89939,
	"./save.svg": 92173,
	"./scheduleDemo.svg": 83532,
	"./scheduleDemo2.svg": 80438,
	"./search.svg": 12054,
	"./selectedRadio.svg": 52570,
	"./send.png": 64806,
	"./send.svg": 61824,
	"./setting.svg": 54618,
	"./share.svg": 52995,
	"./shareIcon.svg": 74788,
	"./shrimp.svg": 48543,
	"./signout.svg": 29739,
	"./single.svg": 25446,
	"./singleSelect.svg": 89614,
	"./singleText.svg": 60379,
	"./solana.png": 3808,
	"./sold.svg": 60612,
	"./solflare.png": 23290,
	"./spaceId.png": 96707,
	"./spot.png": 74020,
	"./stader-header.png": 20725,
	"./staked.svg": 90572,
	"./statement.svg": 80889,
	"./stkBNB.png": 5270,
	"./success.svg": 62831,
	"./successBanner.svg": 27309,
	"./swap.svg": 65823,
	"./tapiocadao-header.png": 68295,
	"./teahouse-logo.svg": 9128,
	"./team.svg": 33921,
	"./telegram.png": 56121,
	"./telegram.svg": 53055,
	"./template.png": 86970,
	"./template.svg": 39284,
	"./tenderfi-logo.png": 75937,
	"./termstructure-header.png": 74645,
	"./thena-header.png": 3548,
	"./thena-logo.png": 45838,
	"./ticket.svg": 42754,
	"./ticketStatus.svg": 81192,
	"./title.png": 82824,
	"./title.svg": 34228,
	"./trash.png": 40716,
	"./trash.svg": 90008,
	"./twitter.png": 87087,
	"./twitter.svg": 42799,
	"./type.svg": 66974,
	"./unclebond-header.png": 79168,
	"./uploadImage.png": 82240,
	"./user.svg": 32751,
	"./userConnect.png": 50427,
	"./userInfo.svg": 32399,
	"./veCRV.svg": 99608,
	"./verify.svg": 71401,
	"./video.svg": 49395,
	"./wLock.svg": 82168,
	"./wdiscord.svg": 75159,
	"./web.svg": 32900,
	"./welcome.svg": 29282,
	"./wgitbook.svg": 98232,
	"./whale.svg": 76701,
	"./whiteIcon.png": 67730,
	"./workspace.png": 96745,
	"./wtelegram.svg": 82624,
	"./wtwitter.svg": 22678,
	"./zee-logo.png": 90208,
	"./zeeverse-header.png": 65805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;